<template>
  <rmr-segmented-control
    class="nrd-display"
    :value="displayMode"
    :items="items"
    :variant="variant"
    @input="displayMode = $event"
  />
</template>

<script>
import { computed, onMounted, reactive } from "@vue/composition-api";
import {
  mdiTable,
  mdiViewAgendaOutline,
  mdiViewGridOutline,
} from "@mdi/js";

import RmrSegmentedControl from "@/components/ui/actions/RmrSegmentedControl.vue";

import useProxy from "@/hooks/useProxy";
import useQueryString from "@/hooks/useQueryString";

export default {
  name: "DisplayFilter",
  components: { RmrSegmentedControl },
  props: {
    // plain sur fond clair, on-dark dans l'en-tête de page.
    variant: {
      type: String,
      default: "plain",
    },
  },
  setup() {
    const { store } = useProxy();

    const { addQueryStringParam, synchronizeFilterWithQueryString } =
      useQueryString();

    const page = reactive({
      isInitialized: false,
    });

    // =>  COMPUTED
    const displayMode = computed({
      get: () => store.getters["newsRadar/getDisplayMode"],
      set: (value) => {
        store.dispatch("newsRadar/updateDisplayMode", value);

        if (page.isInitialized) {
          // Only update user changes, not initialization
          addQueryStringParam({ param: "displayMode", value });
        }
      },
    });

    // =>  HOOKS
    onMounted(async () => {
      await synchronizeFilterWithQueryString({
        dispatcher: "newsRadar/updateDisplayMode",
        param: "displayMode",
        value: displayMode.value,
      });

      page.isInitialized = true;
    });

    // =>  DATA
    return {
      displayMode,
      // Les libellés passent en `title` : à trois modes, les icônes suffisent
      // et l'en-tête de page n'a pas la place de trois étiquettes.
      items: [
        {
          value: "feed",
          icon: mdiViewAgendaOutline,
          title: "Fil d'actualité",
        },
        { value: "masonry", icon: mdiViewGridOutline, title: "Widget" },
        { value: "dataTable", icon: mdiTable, title: "Tableau" },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.nrd-display {
  flex-shrink: 0;
}
</style>
